var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-background-wrapper"},[_c('div',{directives:[{name:"liquid",rawName:"v-liquid",value:(_vm.bgOptions),expression:"bgOptions"}],staticClass:"view-background"})])}
var staticRenderFns = []

export { render, staticRenderFns }